/* eslint-disable import/no-anonymous-default-export */
import maintenanceServices from '../services/maintenance';
import formValidation from '../validation/FormValidation';

const productsLogic = async (page, perPage, paremeters, businessModueId) => {
    const dataResp = await maintenanceServices.prodcutsService(page, perPage, paremeters, businessModueId);
    return dataResp;
}

const bodegasLogic = async (page, perPage, paremeters, businessModueId) => {
    const dataResp = await maintenanceServices.bodegasService(page, perPage, paremeters, businessModueId);
    return dataResp;
}

const accessDataLogic = async (paremeters, businessModueId, userId) => {
    const dataResp = await maintenanceServices.accessData(paremeters, businessModueId, userId);
    return dataResp;
}

const productsByIdLogic = async (paremeters, businessModueId, productId) => {
    const dataResp = await maintenanceServices.productsServiceById(paremeters, businessModueId, productId);
    return dataResp;
}

const saveProductLogic = async (paremeters, businessModueId, productData, productId, saveType) => {
    const validation = formValidation.FormValidatiopn(productData, saveType);
    let dataResp = validation;
    if (!validation.error) {
        let dataSave = {
            sku: productData.sku.value,
            nombre: productData.name.value,
            descripcion: productData.desc.value,
            precio: productData.price.value,
            nemonico_cat: productData.categoria.value,
            nemonico_tipro: productData.tipoProd.value,
            nemonico_marca: productData.marca.value,
            nemonico_modelo: productData.modelo.value,
            nemonico_materiales: productData.meteriales.value,
            nemonico_estados_prod: productData.estados.value,
            bodega_id: productData.bodega.value,
            stock: productData.stock.value,
            status: 'CONFIGH0002',
            grava_iva: productData.ivaSwitch.checked,
            discountPorcent: productData.discountPorcent.value
        }

        let dataSaveDetails = {
            producto_id: productId,
            peso: productData.weight.value,
            alto: productData.height.value,
            ancho: productData.width.value,
            largo: productData.lengthd.value,
            talla: productData.size.value,
            dimensiones: productData.dimensions.value,
            fecha_lanzamiento: productData.launchDate.value,
            fecha_vencimiento: productData.dueDate.value,
            garantia: productData.warranty.value,
            fabricante: productData.manufacturer.value,
            anio_fabricacion: productData.manufacturingYear.value,
            observacion: productData.observation.value
        }
        dataResp = await maintenanceServices.saveProduct(paremeters, businessModueId, dataSave, dataSaveDetails, productId, saveType);
    }
    return dataResp;
}

const getMediaLogic = async (paremeters, moduleId, productoId) => {
    const dataResp = await maintenanceServices.getMedia(paremeters, moduleId, productoId);
    return dataResp;
}

const saveMediaLogic = async (paremeters, moduleId, productoId, media) => {
    const dataResp = await maintenanceServices.saveMedia(paremeters, moduleId, productoId, media);
    return dataResp;
}

const deleteProductLogic = async (paremeters, businessModueId, productId) => {
    const dataResp = await maintenanceServices.deleteProduct(paremeters, businessModueId, productId);
    return dataResp;
}

const usersLogic = async (paremeters, businessModueId) => {
    const dataResp = await maintenanceServices.users(paremeters, businessModueId);
    return dataResp;
}

const usersByIdLogic = async (paremeters, businessModueId, userId) => {
    const dataResp = await maintenanceServices.usersById(paremeters, businessModueId, userId);
    return dataResp;
}

const saveUserLogic = async (paremeters, businessModueId, userData, userId, saveType) => {
    const validation = formValidation.FormValidatiopn(userData, saveType);
    let dataResp = validation;
    if (!validation.error) {
        let dataSave = {
            identification: userData.identification.value,
            names: userData.names.value,
            middle_names: userData.lastName.value,
            direction: userData.direction.value,
            phone: userData.phone.value,
            cellphone: userData.cellPhone.value,
            email: userData.email.value,
            user_name: userData.user.value
        }
        dataResp = await maintenanceServices.saveUsers(paremeters, businessModueId, dataSave, userId, saveType);
    }
    return dataResp;
}

const deleteUserLogic = async (paremeters, businessModueId, userId) => {
    const dataResp = await maintenanceServices.deleteUser(paremeters, businessModueId, userId);
    return dataResp;
}

const businessInfo = async (paremeters, businessModueId) => {
    const dataResp = await maintenanceServices.businessInfo(paremeters, businessModueId);
    return dataResp;
}

const saveBusinessInfoLogic = async (paremeters, businessModueId, businessData) => {
    // falta la validación de cada campo
    const validation = formValidation.FormValidatiopn(businessData, 'E');
    let dataResp = validation;
    if (!validation.error) {
        let dataSave = {
            identification: businessData.ruc.value,
            establishment: businessData.est.value,
            name: businessData.name.value,
            social: businessData.social.value,
            comercial_name: businessData.comercial.value,
            email: businessData.email.value,
            phone: businessData.phone.value,
            cellphone: businessData.cellPhone.value,
            direction: businessData.direction.value,
            mision: businessData.mision.value,
            vision: businessData.vision.value,
            objetive: businessData.obj.value,
        }
        dataResp = await maintenanceServices.saveBusinessInfo(paremeters, businessModueId, dataSave);
    }
    return dataResp;
}

const saveBusinessIMGLogic = async (paremeters, businessModueId, imgData) => {
    const dataResp = await maintenanceServices.saveBusinessImg(paremeters, businessModueId, imgData);
    return dataResp;
}

const getYears = () => {
    const dataResp = maintenanceServices.getYears();
    return dataResp;
}

const parameterByIdLogic = async (paremeters, businessModueId, parameterId) => {
    const dataResp = await maintenanceServices.parameterById(paremeters, businessModueId, parameterId);
    return dataResp;
}

const saveParameterLogic = async (paremeters, businessModueId, parameterData, parameterId, saveType) => {
    // falta la validación de cada campo
    let dataResp;
    if (saveType !== "D" && saveType !== "UI") {
        const validation = formValidation.FormValidatiopn(parameterData, saveType);
        dataResp = validation;
        if (!validation.error) {
            let parameterSave = {
                name: parameterData.nameParam.value,
                description: parameterData.description.value,
                valueParam: parameterData.valueParam.value
            }
            dataResp = await maintenanceServices.saveParameter(paremeters, businessModueId, parameterSave, parameterId, saveType);
        }
    } else {
        if (saveType === "UI") {
            const validation = formValidation.FormValidatiopn(parameterData, saveType);
            dataResp = validation;
            if (!validation.error) {
                let parameterSave = {
                    valueParam: parameterData.iva.value
                }
                dataResp = await maintenanceServices.saveParameter(paremeters, businessModueId, parameterSave, parameterData.ivaId.value, saveType);
            }
        } else {
            dataResp = await maintenanceServices.saveParameter(paremeters, businessModueId, '', parameterId, saveType);
        }
    }
    return dataResp;
}

const templatesLogic = async (paremeters, businessModueId, templateId) => {
    const dataResp = await maintenanceServices.getTemplates(paremeters, businessModueId, templateId);
    return dataResp;
}

const saveTemplatesLogic = async (paremeters, businessModueId, html, desing, data) => {
    // falta la validación de cada campo
    const validation = formValidation.FormValidatiopn(data, 'E');
    let dataResp = validation;
    if (!validation.error) {
        let contHtml = html.replace('style="min-height: 100vh;"', ' ')
        contHtml = contHtml.replace('<meta charset="utf-8">', '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />')
        let dataSave = {
            name: data.name.value,
            description: data.description.value,
        }
        dataResp = await maintenanceServices.saveTemplates(paremeters, businessModueId, contHtml, desing, dataSave);
    }
    return dataResp;
}

const saveAccessbyUserLogic = async (paremeters, businessModueId, userId, accessParam) => {
    const dataResp = await maintenanceServices.saveAccessbyUser(paremeters, businessModueId, userId, accessParam);
    return dataResp;
}

const saveKeysSignLogic = async (paremeters, businessModueId, file, password) => {
    const dataResp = await maintenanceServices.saveKeysSign(paremeters, businessModueId, file, password);
    return dataResp;
}

const saveBodegaLogic = async (paremeters, businessModueId, bodegaData, bodegaId, saveType) => {
    const validation = formValidation.FormValidatiopn(bodegaData, saveType);

    let dataResp = validation;
    if (!validation.error) {
        let dataSave = {
            codigo: bodegaData.codigo.value,
            nombre: bodegaData.nombre.value,
            ubicacion: bodegaData.ubicacion.value,
            estado: bodegaData.estado.value,
            tipo: bodegaData.tipo.value,
        }
        dataResp = await maintenanceServices.saveBodega(paremeters, businessModueId, dataSave, bodegaId, saveType);
    }
    return dataResp;
}

export default {
    productsLogic,
    bodegasLogic,
    usersLogic,
    productsByIdLogic,
    saveProductLogic,
    deleteProductLogic,
    usersByIdLogic,
    saveUserLogic,
    deleteUserLogic,
    businessInfo,
    saveBusinessInfoLogic,
    getYears,
    saveBusinessIMGLogic,
    parameterByIdLogic,
    saveParameterLogic,
    saveTemplatesLogic,
    templatesLogic,
    accessDataLogic,
    saveAccessbyUserLogic,
    saveMediaLogic,
    getMediaLogic,
    saveKeysSignLogic,
    saveBodegaLogic
}
